module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$route.name !== 'Plano') ? _c('header', {
    staticClass: "cf"
  }, [_c('div', {
    staticClass: "headerDiv"
  }, [(
    // hasAccessUpdate('campaign_manager') ||
    //     hasAccessCreate('product_manager') ||
    //     hasAccessCreate('user_manager') ||
    _vm.hasAccessBothAdmin()
  ) ? _c('headerAdmin') : _vm._e(), _vm._v(" "), _c('menuHeader'), _vm._v(" "), (_vm.$route.name !== 'Plano') ? _c('searchHeader', {
    ref: "search"
  }) : _vm._e(), _vm._v(" "), _c('ForecastBanner')], 1), _vm._v(" "), _c('countDown')], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ed2b7b5","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/header/Header.vue
// module id = 3137
// module chunks = 0